/**
 * Table cell rendering the row shortcut to a case's calling history.
 */
import { ClockHistoryIcon } from "../../../../svg/clock-history-icon";

/**
 * Renders a centered clock control; the parent `td` handler opens the non-EPA
 * modal on its History tab.
 *
 * @returns Calling history trigger markup
 */
const CallingHistoryIconCell = () => {
  return (
    <div className="flex justify-center">
      <button
        type="button"
        className="flex cursor-pointer items-center justify-center rounded border-none bg-transparent p-1 hover:bg-primaryGray-16"
        aria-label="View calling history"
      >
        <ClockHistoryIcon />
      </button>
    </div>
  );
};

export default CallingHistoryIconCell;
